<!-- 全局加载状态组件 -->
<script setup lang="ts">
import Loading from '~/assets/icons/loading.svg?component'

const loadingStore = useLoadingStore()

const show = computed(() => loadingStore.show)
const loadingText = computed(() => loadingStore.loadingText)
</script>

<template>
  <Transition name="fade">
    <div
      v-if="show"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 transition-opacity"
    >
      <div class="flex flex-col items-center gap-y-[32px]">
        <Loading class="size-[32px] text-[#E7E7EC] animate-spin" />
        <!-- <span class="text-[16px] text-[#E7E7EC] leading-[20px]">{{ loadingText }}</span> -->
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>